/*
runAfterInit
Custom Knockout bindingHandler that allows you to run a function after an element is initialized.
  https://github.com/knockout/knockout/wiki/Bindings%3A-runafter

Here is a working example:
  http://jsfiddle.net/wfXzT/37/


*/

import ko from 'knockout';

ko.bindingHandlers.runAfterInit = {
  init: function (element, valueAccessor, allBindingsAccessor) {
    // add dependency on all other bindings
    ko.toJS(allBindingsAccessor());
    setTimeout(function () {
      var value = valueAccessor();
      if (typeof value != 'function' || ko.isObservable(value))
        throw new Error('run must be used with a function');
      value(element);
    });
  }
};


/*
 runAfterUpdate
 Custom Knockout bindingHandler that allows you to run a function after an element is updated.
 https://github.com/knockout/knockout/wiki/Bindings%3A-runafter

 Here is a working example:
 http://jsfiddle.net/wfXzT/37/


 */

ko.bindingHandlers.runAfterUpdate = {
  update: function (element, valueAccessor, allBindingsAccessor) {
    // add dependency on all other bindings
    ko.toJS(allBindingsAccessor());
    setTimeout(function () {
      var value = valueAccessor();
      if (typeof value != 'function' || ko.isObservable(value))
        throw new Error('run must be used with a function');
      value(element);
    });
  }
};